import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ListaService } from '../../_services/lista.service';
import { DescripcionErrorIntegracion } from '../../_models/descripcion-error-integracion';
import { DescripcionErrorIntegracionService } from '../../_services/descripcion-error-integracion.service';

@Component( {
  selector: 'app-banco-error-integracion-detalle',
  templateUrl: 'banco-error-integracion-detalle.component.html'
} )

export class BancoErrorIntegracionDetalleComponent implements OnInit {

  carInformacionInicial = true;
  bancoError: DescripcionErrorIntegracion;

  constructor( private serBancoError: DescripcionErrorIntegracionService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private serListas: ListaService,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
        if ( params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined ) {
          this.serBancoError.obtenerPorId( params[ 'id' ] ).subscribe( bancoError => {
            this.bancoError = bancoError;
            if ( !(this.bancoError && (this.bancoError.idDescripcionErrorIntegracion !== null && this.bancoError.idDescripcionErrorIntegracion !== '' && this.bancoError.idDescripcionErrorIntegracion !== undefined)) ) {
              this.navServicio.setMesage( 0, {
                severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'BANCOERROR.MSG_NOEXISREGISTRO' )
              } );
              this.location.back();
            }
            this.carInformacionInicial = false;
          } );
        }
      }
    );
  }


  regresar() {
    this.location.back();
  }

}
